import React, { useEffect, useState } from 'react'
import { Form, InputContainer, ButtonsContainer, Button, DatosBancoVe, InputContainerCedula, InputContainerCedulaEl, ErrorSpan, } from './DepositElements';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../utils/tools';
import axios from 'axios';
import { API_URL } from '../../const/api';
import CopyIcon from '@mui/icons-material/ContentCopy';
import { infoNotification } from '../../utils/toastNotifications';
import venezuela from '../../assets/images/BDVPASA1.png';
import Rtotalpago from '../../assets/images/RECARGACONTOTALPAGO.svg';

const FormTotalPago = ({ form, handleChange, handleClose, handleSubmit, loading }) => {
  const [t] = useTranslation('global');
  const [bancos, setBancos] = useState([]);
  const [showDatos, setShowDatos] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);

  useEffect(() => {
    const getBanks = async () => {
      const res = await axios.post(API_URL + 'getBancosVe', {});
      const filteredBancos = res.data.response.filter(bank =>
        bank.nmbancoTransf === 'Transferencia BDV - MB');
      setBancos(filteredBancos);
    }
    getBanks();
  }, []);


  const handleChangeBanco = (e) => {
    handleChange(e);
    const selectedId = e.target.value;
    if (selectedId !== '') {
      setShowDatos(true);
      const selectedBankData = bancos.find(el => el.idbancoTransf === selectedId);
      setSelectedBank(selectedBankData);
    } else {
      setShowDatos(false);
      setSelectedBank(null);
    }
  }

  const copyContent = async (text, remove) => {
    try {
      let txt = text;
      if (remove) txt = text.substring(1);
      await navigator.clipboard.writeText(txt);
      infoNotification('Contenido copiado al portapapeles', 'top-center');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll('.', '').replace(',', '.')));
    if (e.target.value === '') setMonto(0);
  }

  const handleCancel = () => {
    setSelectedBank(null);
    handleChange({ target: { name: 'idBanco', value: '' } }); // Reiniciar el estado del banco
    handleClose();
  };

  return (
    <>
      <Form>
        <InputContainer>
          <label>{t('deposit.lbl-bank')}</label>
          <select value={form.idBanco} onChange={handleChangeBanco} name='idBanco' style={{color:'#000'}}>
            <option disabled value=''>{t('deposit.input-bank')}</option>
            {bancos.map(item => <option key={item.idbancoTransf} value={item.idbancoTransf}>{item.nmbancoTransf}</option>)}
          </select>
        </InputContainer>

        {showDatos && selectedBank && (
          <>
            <DatosBancoVe>
              <p>Banco: <span>{selectedBank.nmbancoTransf}</span></p>
              <p>Nombre: <span>{selectedBank.nmTitularCuentaTransf}</span></p>
              <p>Cuenta: <span>{selectedBank.nuCuentaBancoTransf}</span> <CopyIcon onClick={() => copyContent(selectedBank.nuCuentaBancoTransf, false)} /></p>
              <p>RIF: <span>{selectedBank.rifTitularCuentaTransf}</span> <CopyIcon onClick={() => copyContent(selectedBank.rifTitularCuentaTransf, true)} /></p>
              <p>Recarga Mínima: <span>10 VES</span></p>
            </DatosBancoVe>
          </>
        )}

        {showDatos && (
          <>
            <InputContainer>
              <label>NOMBRE COMPLETO:</label>
              <input type='text' placeholder='NOMBRE TITULAR' name='nombre' value={form.nombre} onChange={handleChange} />
            </InputContainer>
            <InputContainer>
              <label>REFERENCIA:</label>
              <input type='text' placeholder='REFERENCIA' name='referencia' value={form.referencia} onChange={handleChange} />
            </InputContainer>

            <InputContainer>
              <label>FECHA PAGO:</label>
              <input type='date' name='fecha' value={form.fecha} onChange={handleChange} />
            </InputContainer>

            <InputContainer>
              <label>{t('deposit.lbl-amount')}</label>
              <input type='text' placeholder='0,00' name='monto1' value={form.monto1} onChange={(e) => handleMonto(e)} />
              {monto < 10 && blur && (
                <ErrorSpan>{t("deposit.amount-greater-than")} 10 VES</ErrorSpan>
              )}

              {monto > 200000 && blur && (
                <ErrorSpan>{t("deposit.amount-less-than")} 200.000 VES</ErrorSpan>
              )}
            </InputContainer>
          </>
        )}

        <img src={Rtotalpago} alt='astropay' className={'totalpago1'} style={{width:'50%', marginLeft: '24%', marginTop: '5%', marginBottom:'2%'}}/>
        <img src={venezuela} alt='Pasarelas Tupay' className={'totalpago2'} style={{width:'140%', marginTop: '2%', marginLeft: '-20%'}}/>
      
        <ButtonsContainer style={{marginTop:'-90px'}}>
          <Button onClick={handleCancel}>{t('deposit.btn-cancel')}</Button>
          <Button primary={true} disabled={(loading || monto < 10 || monto > 200000)} onClick={handleSubmit}>{loading ? 'CARGANDO...' : t('deposit.btn-confirm')}</Button>
        </ButtonsContainer>
      </Form>
    </>
  )
}

export default FormTotalPago;